import { useEffect, useState, useRef } from 'react'
import Tabs from '../../../../Components/Tabs'
import GetIcon from '../../../../utils/Icon'
import { useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import Table from './Table'
import Button from '../../../../Core/Button/Button'
import printerimg from "../../../../assets/print.png"
import { usePostMappedPicklistMutation, useLazyGetPicklistDetailsQuery, usePostCreatePicklistMutation,
	 usePostUpdatePickListMutation, usePostSubmitPickListMutation } from '../../../../store/api/picklist'
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import PrintModal from "../../../../../src/Core/Print/PrintModal";
import Attachment from '../../../../utils/Attachment'
import { useGetSalesOrderIdListMutation } from '../../../../store/api/salesorderapi'

function Pick({ order_id }) {
    const nvg = useNavigate();
    const scanItemRef = useRef(null);
    const [tab, settab] = useState(1);
    const [result, setResult] = useState(false);
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [item_Rows, setitem_Rows] = useState([]);
    const [originalItems, setOriginalItems] = useState([]);
    const [fulldata, setfulldata] = useState();
	console.log("scannedserialNoscannedserialNoscannedserialNo ddd",originalItems,fulldata,item_Rows)
    const [scannedserialNo, setscannedserialNo] = useState([]);
    const [current_scanned_bin, setCurrent_Scanned_Bin] = useState('');
    const [scannedItem, setScannedItem] = useState('');
    const [scanboll, setscanboll] = useState(false);
    const [picklist_id, setpicklist_id] = useState();
    const [submit, setsubmit] = useState(false);
    const [update, setupdate] = useState(false);
    const [selectRow, setselectRow] = useState("");
    const [newPageNumber, setnewPageNumber] = useState(1);
	  const [selectedso, setselectedso] = useState('');
    const [activityboll, setactivityboll] = useState(false)
    const [showPrintModal, setShowPrintModal] = useState(false);
	const [solist, setsolist] = useState([]);
	const [SOListApi] = useGetSalesOrderIdListMutation();
	console.log("setsolistsetsolist",solist);
    const [checkbool, setcheckbool] = useState(false)
    const [postMappedPicklist] = usePostMappedPicklistMutation();
    const [trigger] = useLazyGetPicklistDetailsQuery();


	useEffect(()=>{
      if(order_id){
		setselectedso(order_id);
	  }
	},[order_id])

	 useEffect(()=>{
	//   if(!selectedpo){
		   const getsofun = async () =>{
	
			const response = await SOListApi().unwrap();
			// console.log("Res SO List", response);
			console.log("response os soosss sosososos",response);
			// const temp = response?.message?.values;
			const names = response?.message?.values.map((item) => ({ name: item[0] }));

			// setSalesOrderList(temp.map(item => item[0]))
			// console.log("SO list",salesOrderList)
			 setsolist(names)

			}
	
			getsofun();
		// }
	  },[])

    useEffect(() => {
    const fetchPicklist = async () => {
        try {
            const res = await postMappedPicklist(selectedso).unwrap();

            setfulldata(res);

            let updatedRows = res.message.locations.map(item => ({
            ...item,
            picked_qty: 0,
            Sno: item?.serial_no ? item?.serial_no?.split(/[\n\\]+/) : [],
            Scanned_Sno: []
            }));
             console.log("check 1",updatedRows);
            setscanboll(true);
            setItemList(updatedRows);
            setOriginalItems(updatedRows);
            setitem_Rows(updatedRows);
        } catch (error) {
            console.error("Error fetching picklist:", error);
        }
    };


    if (selectedso) {
         fetchPicklist();
     }else{
		setitem_Rows([]);
		setOriginalItems([]);
		setItemList([]);
	 }

    }, [selectedso, postMappedPicklist]);

    const handleBinScan = (e) => {
        scanItemRef.current?.focus();
        e.preventDefault();
        if (current_scanned_bin.trim()) {
            const filtered = originalItems.filter(item => item.warehouse === current_scanned_bin.trim());
            setitem_Rows(filtered);
        } else {
            handleClearBinFilter();
        }
        setnewPageNumber(1);
    };

    const handleClearBinFilter = () => {
        setCurrent_Scanned_Bin('');
        const updatedOriginalItems = originalItems.map(origItem => {
            const updated_SItem = item_Rows.find(updatedItem => updatedItem.item_code === origItem.item_code && updatedItem?.batch_no === origItem?.batch_no && updatedItem?.serial_no == origItem?.serial_no && updatedItem?.Sno[0] && origItem?.Sno[0]);
            const updated_NSItem = item_Rows.find(updatedItem => updatedItem.item_code === origItem.item_code && updatedItem.warehouse === origItem.warehouse && !updatedItem?.serial_no && !origItem?.serial_no);
           console.log("check 11111",updated_SItem)
           console.log("check 22222",updated_NSItem)
			if (updated_SItem && updated_SItem != undefined) {
           console.log("check 11111 AGAIN",updated_SItem)
                return {
                    ...origItem,
                    picked_qty: updated_SItem?.picked_qty,
                    Scanned_Sno: updated_SItem?.Scanned_Sno,
                };
            }
            if (updated_NSItem && updated_NSItem != undefined) {
              console.log("check 22222 AGAIN",updated_NSItem)
                return {
                    ...origItem,
                    picked_qty: updated_NSItem?.picked_qty,
                };
            }     
            return {
                    ...origItem
                };
        });
        console.log("check 333",updatedOriginalItems);
        setitem_Rows(updatedOriginalItems);
        setOriginalItems(updatedOriginalItems)
    };

    const handleItemScan = (e) => {
        e.preventDefault();
        setScannedItem("");


        if (scannedItem.trim()) {
   
            let matchedItem = null;
            let filtered = [];
            const serialItem = item_Rows.filter((item) => item.Sno?.includes(scannedItem));
            if (serialItem.length > 0) {
             filtered = item_Rows.map((item) => {
                    if (item.Sno?.includes(scannedItem)) {
                        if (!(item.warehouse === current_scanned_bin.trim())) {
                            setError(`Item needs to be in the same Warehouse`);
                            setShowError(true);
                            return item;
                        }
						const currentPickedQty = parseInt(item.picked_qty || 0);
                        const totalQty = parseInt(item.qty || 0);
                
                        if (currentPickedQty >= totalQty) {
                            setError(`Picked quantity exceeds available quantity`);
                            setShowError(true);
                            return item;
                        }

                        if (scannedserialNo.includes(scannedItem)) {
                            setError(`Serial number ${scannedItem} already scanned`);
                            setShowError(true);
                            return item;
                        }

						
                        setscannedserialNo([...scannedserialNo, scannedItem]);
                        // item.picked_qty = currentPickedQty + 1;
                        // item.Scanned_Sno = [...item.Scanned_Sno, scannedItem];
                        // matchedItem = { ...item };
                        matchedItem = { ...serialItem[0],Scanned_Sno:[...serialItem[0].Scanned_Sno, scannedItem],picked_qty:(parseInt(serialItem[0].picked_qty || 0) + 1) };
						
                        setnewPageNumber(1)
                    }

                    return item;
                });

                if (matchedItem !== null) {
                     const updatedList = [
                        matchedItem,
                        ...filtered.filter((item) => !item.Sno?.includes(scannedItem) ),
                    ];

                    setitem_Rows(updatedList);
                    setselectRow(matchedItem);
                    setnewPageNumber(1)

                }
                return;

            }else{
             filtered = item_Rows.map((item) => {

                if(item.item_code == scannedItem.trim()){
                    if(item.Sno[0]){
                        return item;
                    }
                }
                if (!(item.warehouse == current_scanned_bin.trim())) {
                    setError(`Item needs to be in the same Warehouse`);
                    setShowError(true);
                    return item;
                }

                if (item.item_code === scannedItem.trim()) {
                    const currentPickedQty = parseInt(item.picked_qty || 0);
                    const totalQty = parseInt(item.qty || 0);

                    if (currentPickedQty >= totalQty) {
                        setError(`Picked quantity exceeds available quantity`);
                        setShowError(true);
                        return item;
                    }

                    item.picked_qty = currentPickedQty + 1;
                    matchedItem = { ...item };
                    setnewPageNumber(1)

                }

                return item;
            });
    
            if (matchedItem !== null) {
                const updatedList = [
                    matchedItem,
                    ...filtered.filter((item) => item.item_code !== matchedItem.item_code),
                ];

                setitem_Rows(updatedList);
                setselectRow(matchedItem);
            }else{
				 setError(`Item not Found`);
                            setShowError(true);
                            return ;
			}

             }


        }


    };

    const totalPickedQty = item_Rows.reduce((total, item) => {
        return total + (Number(item?.picked_qty) || 0);
    }, 0);

    const totalQty = item_Rows.reduce((total, item) => {
        return total + (item?.order_qty || 0);
    }, 0);

    const totalaccepted = item_Rows.reduce((total, item) => {
        return total + (item?.qty || 0);
    }, 0);

    const [postCreatePicklist, { isLoading, isSuccess, isError }] = usePostCreatePicklistMutation();

    const pickListdetail = async (pick_id) => {

        const ApiResponse = await trigger({ doctype: 'Pick List', name: pick_id }).unwrap();
        setfulldata(ApiResponse);

        const returnData = item_Rows.map(item => {
    const scanned_q_ser = item.Sno;
    
    // Find the first matching location (using find instead of forEach)
    const matchedLocation = ApiResponse.message.locations.find(nameLocation => {

        if (nameLocation.serial_no?.includes(scanned_q_ser[0])) {
            return true;
        }

        if (nameLocation.serial_no == null && nameLocation.warehouse == item.warehouse && nameLocation.item_code == item.item_code) {
            return true;
        }
        return false;
    });


    if (matchedLocation) {
        return { ...item, name: matchedLocation.name };
    }
    return item;
});

        return returnData;
    };



    const pickListdetailtwo = async (pick_id) => {
        try {
            const ApiResponse = await trigger({ doctype: 'Pick List', name: pick_id }).unwrap();

            return ApiResponse;
        } catch (err) {
            console.error('Error in pickListdetailtwo:', err);
            throw err;
        }
    };

    const handleClick = async () => {
        if (result) return;

        if (!item_Rows?.length) {
            console.warn('No items to save.');
            return;
        }
        const payload = {
            order_id: item_Rows[0]?.sales_order || '',
            items: item_Rows.reduce((acc, current) => {
                const existingItem = acc.find(item => item.item_code === current.item_code);
                if (existingItem) {
                    existingItem.qty += current.qty;
                } else {
                    acc.push({
                        item_code: current.item_code,
                        qty: current.qty,
                    });
                }
                return acc;
            }, []),
        };

    

        try {
            const res = await postCreatePicklist(payload).unwrap();
  
            setpicklist_id(res.result.pick_list);

            const updatedRows = await pickListdetail(res.result.pick_list);
            console.log("row detail line is here",updatedRows);
            setItemList(updatedRows);
            setOriginalItems(updatedRows);
            setitem_Rows(updatedRows);
            setJustUpdatedRows(updatedRows);


            // setdummyitem(updatedRows);

            // handleClicksave(res.result.pick_list, updatedRows);
        } catch (err) {
            console.error('Error creating picklist:', err);
        }
    };


    const [postupdatePicklist] = usePostUpdatePickListMutation();

    const handleClicksave = (pick_id, updatedRows) => {
        if (result) return;

        const rowsToUse = updatedRows?.length ? updatedRows : item_Rows;

        if (!rowsToUse?.length) {
            console.warn('No items to save.');
            return;
        }

        const payload = {
            name: pick_id || picklist_id,
            locations: rowsToUse.map(item => ({
                name: item.name,
                item_code: item.item_code,
                warehouse: item.warehouse,
                picked_qty: parseInt(item.picked_qty) || 0,
                qty: parseInt(item.picked_qty) || 0,
                serial_no: item.Scanned_Sno,
                batch_no: item.batch_no
            })),
        };

        postupdatePicklist(payload)
            .unwrap()
            .then(res => {
                setupdate(true)
                setError('Picklist Updated');
                setptype('Updated');
                setShowError(true);
                setactivityboll(prev => !prev);
                setcheckbool(true)
                  setitem_Rows(updatedRows);
                return pickListdetailtwo(pick_id || picklist_id);
            })
            .then(() => {
                console.log("Both operations completed successfully");
            })
            .catch(err => {
                alert('Error creating picklist:', err)
                console.error('Error creating picklist:', err);
            });
    };



    const [postsubmitPicklist] = usePostSubmitPickListMutation();

    const handleClicksubmit = () => {
        if (result) return;

        if (!item_Rows?.length) {
            console.warn('No items to save.');
            return;
        }

        const payload = {
            name: picklist_id,

        };


        postsubmitPicklist(payload)
            .unwrap()
            .then(res => {
                setsubmit(true)
                setError('Submited');
                setptype('Picklist submited');
                setShowError(true);
                setactivityboll(prev => !prev);

            })
            .catch(err => {
                console.error('Error creating picklist:', err);
            });
    };



    const handleDevlivaryPick = async () => {
        try {
            localStorage.removeItem("deliveryNoteId");
            nvg('/outbound/outbound-create-delivery-note', {
                state: { picklist_id: picklist_id, is_new: true }
            });
        } catch (error) {
            console.error('Failed to create pick:', error);
            alert('Error creating pick. Please try again.');
        }
    };



    const [justUpdatedRows, setJustUpdatedRows] = useState(null);

    useEffect(() => {
    if (justUpdatedRows && picklist_id) {
        handleClicksave(picklist_id, justUpdatedRows);
        setJustUpdatedRows(null);
    }
    }, [justUpdatedRows, picklist_id]);

    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between p-2 " style={{ background: "#fcfdfe", height: '40px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0"><GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /></p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/pick/outboundpick')}>Pick List </p>
                    <p className="m-0"><GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /></p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
                        New Pick
                        <button
                            className={` ${submit
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {submit ? 'Submitted' : scanboll ? 'Draft' : 'New'}
                        </button>
                    </a>
                </div>
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                    {submit && <Button
                        style={{ gap: '2px' }}
                        className="custom-btn-00989"
                        iconName="LuFilePlus2"
                        iconSize={12}
                        onClick={handleDevlivaryPick}
                        disabled={isLoading}
                    >
                        Create Delivary note
                    </Button>}

                   
                    {!submit && (

                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={() => {
                                checkbool ? handleClicksave() : handleClick()
                            }}
                            disabled={isLoading}
                        >
                            {checkbool ? 'Update' : 'Save'}
                        </Button>
                    )}
                    {update && !submit && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleClicksubmit}
                            disabled={isLoading}
                        >
                            Submit
                        </Button>
                    )}
                    {update && (
                        <p className="p-0 m-0">
                            <img src={printerimg}
                                onClick={() => setShowPrintModal(true)}
                                className="px-2" style={{ width: '35px', cursor: 'pointer' }} alt="404" />
                        </p>
                    )}
                </div>
            </div>
            <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                        {picklist_id && <Attachment doctype="Pick List" docname={picklist_id} />}
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
                    <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1
						so={{
							solist,
							selectedso,
							setselectedso
						}}
						 polist
              selectedpo
              setselectedpo
						 fulldata={fulldata}
						 order_id={selectedso}
						 activityboll={activityboll}
						 picklist_id={picklist_id} />
                    </div>
                    <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>
                            {/* Left Side Text Info */}
                            <div className="d-flex" style={{ gap: '10px' }}>
                                <p className="NoOfLine">
                                    No. of lines - <span style={{ color: '#2563EB' }}>{item_Rows.length}</span>
                                </p>
                                <p className="TotalQty">
                                    Total Quantity - <span style={{ color: '#16A34A' }}>{totalaccepted > 0 ? totalaccepted : totalQty}</span>
                                </p>
                                <p className="ReceivedQty">
                                    Scanned Quantity - <span style={{ color: '#EC642A' }}>{totalPickedQty}</span>
                                </p>
                            </div>
                            {scanboll &&
                                <div className="d-flex mx-2" style={{ gap: '10px', borderColor: 'rgba(0,0,0,0.2)' }}>
                                    <form onSubmit={handleBinScan}>
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                name="binScan"
                                                placeholder="Scan Bin"
                                                className="form-control pe-4"
                                                value={current_scanned_bin}
                                                onChange={(e) => setCurrent_Scanned_Bin(e.target.value)}
                                                style={{
                                                    width: '227px',
                                                    border: '1px solid #333',
                                                    fontSize: '12.8px'
                                                }}
                                            />
                                            <button
                                                type="submit"
                                                className="position-absolute"
                                                style={{
                                                    top: '50%',
                                                    right: '10px',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    color: "#EC642A",
                                                    fontSize: '12.8px'
                                                }}
                                            >
                                                <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                            </button>
                                        </div>
                                    </form>



                                    <form onSubmit={handleItemScan}>
                                        <div className="position-relative" style={{ width: '227px' }}>
                                            <div
                                                style={{ position: 'relative' }}
                                                title={!current_scanned_bin ? 'Scan Bin' : ''}
                                            >
                                                <input
                                                    ref={scanItemRef}
                                                    type="text"
                                                    placeholder="Scan Item"
                                                    className="form-control pe-4"
                                                    value={scannedItem}
                                                    onChange={(e) => setScannedItem(e.target.value)}
                                                    disabled={!current_scanned_bin}
                                                    style={{
                                                        width: '100%',
                                                        border: '1px solid #333',
                                                        backgroundColor: !current_scanned_bin ? '#f1f1f1' : 'white',
                                                        cursor: !current_scanned_bin ? 'not-allowed' : 'text',
                                                        fontSize: '12.8px'
                                                    }}
                                                />

                                                {!current_scanned_bin && (
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            right: '40px',
                                                            transform: 'translateY(-50%)',
                                                            pointerEvents: 'none',
                                                            color: '#999',
                                                        }}
                                                    >
                                                        <GetIcon iconName="MdBlock" size={16} />
                                                    </div>
                                                )}
                                            </div>

                                            <button
                                                type="submit"
                                                className="position-absolute"
                                                disabled={!current_scanned_bin}
                                                style={{
                                                    top: '50%',
                                                    right: '10px',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: !current_scanned_bin ? 'not-allowed' : 'pointer',
                                                    color: "#EC642A",
                                                }}
                                                title={!current_scanned_bin ? 'Scan Bin' : 'Submit'}
                                            >
                                                <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                            </button>
                                        </div>

                                    </form>
                                </div>}

                        </div>

                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table
                            pageNo={{ newPageNumber, setnewPageNumber }}
                            scannedserialNo={{ setscannedserialNo, scannedserialNo }}
                            list_data={itemList}
                            fulldata={fulldata}
                            row={{ Rows: item_Rows, setRows: setitem_Rows, selectRow, setselectRow }}
                            scanboll={scanboll}
                            submit={submit} />

                    </div>
                </div>
                {showPrintModal && (
                    <PrintModal
                        onClose={() => setShowPrintModal(false)}
                        documentId={picklist_id}
                        doctype="Pick List"
                        title="Print Pick List"
                    />
                )}
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </div>
        </>
    )
}

export default Pick